import { Card, CardContent, Typography, Box } from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import React, { useRef, useState, forwardRef, useImperativeHandle } from 'react';

const PacingUploadExcel = forwardRef(({ onFileSelected }, ref) => {
  const fileInputRef = useRef(null);
  const [isDragOver, setIsDragOver] = useState(false);
  const [fileName, setFileName] = useState('');

  const handleBoxClick = () => {
    fileInputRef.current.click();
  };

  /**
   * 1) Instead of parsing, simply store the file and forward it
   *    to the parent component for uploading.
   */
  const handleFilePicked = (file) => {
    setFileName(file.name);
    if (onFileSelected) {
      onFileSelected(file);
    }
  };

  const handleFileChange = (event) => {
    if (event.target.files.length > 0) {
      handleFilePicked(event.target.files[0]);
    }
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    setIsDragOver(true);
  };

  const handleDragLeave = (event) => {
    event.preventDefault();
    setIsDragOver(false);
  };

  const handleDrop = (event) => {
    event.preventDefault();
    setIsDragOver(false);

    if (event.dataTransfer.files && event.dataTransfer.files.length > 0) {
      handleFilePicked(event.dataTransfer.files[0]);
      event.dataTransfer.clearData();
    }
  };

  /**
   * 2) You can still expose processExternalFile if you want the parent
   *    to programmatically pass you a File object.
   */
  useImperativeHandle(ref, () => ({
    processExternalFile: (file) => {
      handleFilePicked(file);
    },
  }));

  return (
    <div>
      <Card
        sx={{
          border: '2px dashed #ccc',
          borderRadius: '8px',
          cursor: 'pointer',
          transition: 'border-color 0.3s',
          backgroundColor: isDragOver ? '#f0f0f0' : 'transparent',
          '&:hover': {
            borderColor: '#999',
          },
          mb: 2,
        }}
        onClick={handleBoxClick}
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
      >
        <CardContent>
          <Box sx={{ textAlign: 'center', color: '#666' }}>
            <CloudUploadIcon sx={{ fontSize: 48 }} />
            <Typography variant="h6" sx={{ mt: 2 }}>
              Upload Excel File
            </Typography>
            <Typography variant="body2" sx={{ mt: 1 }}>
              Drag and drop an Excel file here or click to upload
            </Typography>
          </Box>
          <input
            type="file"
            accept=".xls,.xlsx"
            ref={fileInputRef}
            style={{ display: 'none' }}
            onChange={handleFileChange}
          />
        </CardContent>
      </Card>
      {fileName && <Typography variant="body2">Uploaded file: {fileName}</Typography>}
    </div>
  );
});

export default PacingUploadExcel;
